import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

/** 未安装终端项 */
export interface UninstalledTerminalItem {
  computer_name: string
  /** 首次发现时间 */
  first_time?: number
  /** 硬件信息 */
  hardware_info?: string
  /** IP地址 */
  ip_address?: string
  /** 末次发现时间 */
  last_time?: number
  /** Mac地址 */
  mac?: string
  /** 备注 */
  remarks?: string
  /** 子网地址 */
  subnet_address?: string
  /** 操作系统 */
  system_name?: string
}

/** 未安装终端列表请求 */
export interface UninstalledTerminalListReq {
  /** 子网地址开始 */
  subnet_address_start: string
  keyword?: string
  /** 每页数量 */
  limit?: number
  /** 页码 */
  page?: number
  /** 子网地址结束 */
  subnet_address_end?: string
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type?: number
  /** 排序字段 */
  sort?: string
  /** 是否升序 */
  asc?: boolean
}

/** 未安装终端列表响应 */
export interface UninstalledTerminalListRes {
  list?: UninstalledTerminalItem[]
  total?: number
}

@Injectable()
export class UninstalledTerminalDrawerService {
  constructor (private http: Http) {
  }

  /** 获取未安装终端列表 */
  @ParamsClean()
  @InvokeThrottle()
  getUninstalledTerminalList (data: UninstalledTerminalListReq) {
    data.system_type ||= undefined
    return this.http.post<UninstalledTerminalListRes>('/client_find/un_install_list', data)
  }

  /** 导出未安装终端列表 */
  downloadUninstalledTerminalList (type: 0 | 1, options: UninstalledTerminalListReq, moduleName: string) {
    const params = {
      ...options,
      file_type:type,
      limit: 0,
      page: 0
    }
    params.system_type ||= undefined
    return this.http.downloadWithBlob('/client_find/un_install_list_export', params, moduleName)
  }
}

